import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_kalender } from "../Controls/dbh_kalender";
import { dbh_suchergebnis } from "../Controls/dbh_suchergebnis";
import { dbh_helper } from "../src/dbh_helper";
import { dbh_loading } from "../src/dbh_loading";
import { dbh_custom_validation } from "../ClientValidation/dbh_custom_validation";
import { dbh_filePreview } from "../Controls/dbh_filePreview";

let eventKeypressReminder = null;

if (dbh_helper.getUrlArea() == "index" || dbh_helper.getUrlArea() == "") {
    $("#dbh_dashboard").ready(function () {
        if ($("#dbh_dashboard") && $("#dbh_dashboard").length > 0) {

            dbh_helper.OnSetDefaultFormValues = () => {
                BindDashboardAufgaben();
                initSortableFavList();
            };

            $("#goalLink").on("click", function () {
                const base = $(this).data("base") as string;
                const param = $(this).data("param") as string;
                const value = $(this).data("value") as string;
                window.open(base + "?" + param + "=" + value, "_blank");
            });

            $("#newsMoreInfoBtn").on("click", function () {
                new dbh_ajax().sendGetRequest({
                    actionName: "NewsPopupView",
                    controllerName: "Home",
                    parameter: [["id", $(this).data("id")]],
                    callbackSuccess: (ajaxResult: any) => {
                        $('#news-placeholder').html(ajaxResult.responseText);
                        $('#NewsViewComponentPopup').fadeIn("fast");
                    },
                    callbackError: (ajaxResult: object) => {

                    }
                });
            });

            dbh_helper.initBoxSlider("infoSlider");

            $('#AlleFelder.ignoreSubmit').on('keyup', function (e) {

                if (e.keyCode === 10 || e.keyCode === 13) {
                    e.preventDefault();
                }
                if (eventKeypressReminder != null) {
                    window.clearTimeout(eventKeypressReminder);
                }

                const $input = $(this);

                eventKeypressReminder = window.setTimeout(function () {
                    const parent = $input.closest(".dbhSuchergebnis");
                    const tiles = parent.find(".dbhSuchergebnisKachel");
                    const val = $input.val().toString().toLocaleLowerCase();

                    if (val.toString().length === 0) {
                        tiles.show();
                    } else {
                        for (let i = 0; i < tiles.length; i++) {
                            const $curTile = $(tiles[i]);
                            const $forFilter = $curTile.find(".forFilter");

                            let found = false;
                            for (let j = 0; j < $forFilter.length; j++) {
                                if ($forFilter[j].innerHTML.toLocaleLowerCase().indexOf(val) >= 0) {
                                    found = true;
                                }
                            }

                            if (found) {
                                $curTile.show();
                            } else {
                                $curTile.hide();
                            }
                        }
                    }

                }, 500);
            });

            $(document).on("click", ".aufgabeClose", function () {
                (window as any).hidePopup('PopupAufgabenVorverarbeitungViewComponent');
            });

            $(document).on("click", "[data-setstepindex]", function () {
                const index = $(this).data("setstepindex");
                setStep(index);
            });

            $('.dbhErinnerung').on('click', (e) => {
                dbh_helper.SendGetRequest("ErinnerungPopupView", "Home", [['id', $(e.currentTarget).attr('data-aufgabe')]], '#reminder-placeholder', function () {
                    $("#PopupErinnerungViewComponent").show();
                });

                e.stopPropagation();
            });

            $(document).on("click", "#reminderSavetBtn", function (e) {
                const form = dbh_helper.findNearestForm(e.currentTarget);

                let dbhCustomValidation = new dbh_custom_validation();
                if (!dbhCustomValidation.validateForm(form)) {
                    return;
                }

                let rawZeitpunkt = $(form).find("#Zeitpunkt").val().toString();
                var parameter = [["id", $(e.currentTarget).attr('data-aufgabe')], ["zeitpunkt", rawZeitpunkt]];
                dbh_helper.FormatDatesParameterArray(parameter);

                new dbh_ajax().sendPostRequest({
                    csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                    actionName: "AddOrEditErinnerung",
                    controllerName: "Home",
                    parameter: parameter,
                    callbackSuccess: (ajaxResult: any) => {
                        $('#listeAllerAufgabenUndNachrichten .dbhErinnerung[data-aufgabe="' + $(e.currentTarget).attr('data-aufgabe') + '"]').first().addClass('active');
                        $("#PopupErinnerungViewComponent").hide();
                    }
                });
            });

            $(document).on("click", "#reminderDeleteBtn", function (e) {
                const form = dbh_helper.findNearestForm(e.currentTarget);

                new dbh_ajax().sendPostRequest({
                    csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                    actionName: "DeleteErinnerung",
                    controllerName: "Home",
                    parameter: dbh_helper.getParameterArrayForForm(form),
                    callbackSuccess: (ajaxResult: any) => {
                        $('#listeAllerAufgabenUndNachrichten .dbhErinnerung[data-aufgabe="' + $(e.currentTarget).attr('data-aufgabe') + '"]').first().removeClass('active');
                        $("#PopupErinnerungViewComponent").hide();
                    }
                });

            });

            $(document).on("click", "#reminderCancelBtn", function () {
                $("#PopupErinnerungViewComponent").hide();
            });

            // Auf iPhone wird PDF als Dateiformat für die Kamera-Aufnahme nicht unterstützt bzw. sinnvoll angeboten -> daher dort ohne PDF im accept-Attribut
            if (dbh_helper.isIPhone()) {
                $("#fileNeuesFoto").attr("accept", "image/*");
            }

            // Bindet den change-Handler an das aktuell im DOM befindliche #fileNeuesFoto-Element.
            // Wird nach jedem Upload erneut aufgerufen, da das Input-Element per Klon ersetzt wird
            // (Workaround für iOS-PWA/WKWebView-Standalone-Modus: dort wird das native
            // File-Handle nach der ersten Nutzung nicht zuverlässig freigegeben, wodurch ein
            // zweiter Foto-Upload sonst nicht mehr funktioniert - im normalen Safari-Tab tritt
            // dieses Verhalten nicht auf).
            const bindFileNeuesFotoChangeHandler = () => {
                const $input = $("#fileNeuesFoto");
                $input.off("change");
                $input.on("change", function (e) {
                    var input = this as HTMLInputElement;

                    if (input.files && input.files[0]) {
                        const extension = input.files[0].name.split('.').pop().toLocaleLowerCase();
                        const size = input.files[0].size;
                        const allowedExtension = [".jpg", ".jpeg", ".png", ".tiff", ".pdf"];
                        let error = false;
                        var form: JQuery<HTMLFormElement> = dbh_helper.findNearestFormJquery($(e.currentTarget));
                        var formData = new FormData(form.get(0));

                        if (size > (10 * 1024 * 1024)) {
                            setTimeout(() => alert('Die Datei darf nicht größer als 10 MB sein.'), 0);
                            error = true;
                        }
                        else if (allowedExtension.indexOf(`.${extension}`) == -1) {
                            setTimeout(() => alert('Es sind nur die Formate jpg, jpeg, tiff, png und pdf erlaubt.'), 0);
                            error = true;
                        }
                        else {
                            for (var i = 0; i < input.files.length; i++) {
                                formData.append("foto" + i.toString(), input.files[i], input.files[i].name);
                            }
                        }

                        const resetFileInput = () => {
                            // Input-Element klonen und ersetzen statt nur input.value zurückzusetzen:
                            // in der iOS-PWA (WKWebView Standalone) reicht ein reines Zurücksetzen
                            // des value nicht zuverlässig aus, um einen erneuten Foto-Upload zu ermöglichen.
                            const $oldInput = $("#fileNeuesFoto");
                            const $newInput = $oldInput.clone(false);
                            $newInput.val("");
                            $oldInput.replaceWith($newInput);
                            bindFileNeuesFotoChangeHandler();
                        };

                        if (!error) {
                            new dbh_ajax().sendPostRequest({
                                csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                                actionName: "FotoHinzufuegen",
                                processData: false, // wichtig für File-Upload
                                contentType: false, // wichtig für File-Upload
                                controllerName: "WorkflowS/Sachkostenabrechnungen",
                                parameter: formData,
                                callbackSuccess: (ajaxResult: any) => {
                                    window.location.href = `/workflows/Sachkostenabrechnungen/BelegDetails?id=${ajaxResult}`;
                                },
                                callbackError: () => {
                                    resetFileInput();
                                }
                            });
                        }
                        else {
                            resetFileInput();
                        }
                    }
                });
            };

            bindFileNeuesFotoChangeHandler();
        }
    });

    const setStep = (index) => {
        $('.dbhDokumentWeiterleitenStep').fadeOut(400);
        window.setTimeout(function () {
            $('.dbhDokumentWeiterleitenStep' + index).fadeIn();
        }, 400);

        if (index == 1) {
            $('.btnListDefault').fadeIn();
            $('.btnListDefault .btnPrimary').parent().hide();
        }
        else {
            $('.btnListDefault').fadeOut();
        }
    };

    // Timeout setzen, da erst die Skripte alle geladen werden müssen...
    window.setTimeout(() => {
        //@ts-ignore
        //var driverObjInstance = driver();

        $('#dbh_dashboard #aussenstaendeBox #btnShowHilfeAussenstaende').off('click');
        $('#dbh_dashboard #aussenstaendeBox #btnShowHilfeAussenstaende').on('click', (e) => {
            //@ts-ignore
            var driverObjAussenstaende = driver();
            driverObjAussenstaende.highlight({
                element: "#dbh_dashboard #aussenstaendeBox",
                popover: {
                    title: "Aktuelle Außenstände meiner Belegungen",
                    description: `Es werden nur unbezahlte Rechnungen angezeigt, die <strong>vor mehr als 8 Wochen gestellt</strong> wurden.<br /><br />Erst nach Ablauf des Zahlungsziels und Ausbleiben der Zahlung nach der ersten Mahnung werden diese Außenstände hier berücksichtigt.<br /><br /><a id="btnHilfeAussenstaendeClose" class="btn btnDriverClose">Verstanden</a>`
                },
                onHighlighted: () => {
                    window.setTimeout(() => {
                        $('#btnHilfeAussenstaendeClose').on('click', (e) => {
                            driverObjAussenstaende.destroy();
                        });
                    }, 500);
                }
            });
            e.stopPropagation();
        });

        $('#dbh_dashboard #sachkostenabrechnungBox #btnShowHilfe').off('click');
        $('#dbh_dashboard #sachkostenabrechnungBox #btnShowHilfe').on('click', (e) => {
            //@ts-ignore
            var driverObjInstance = driver();
            driverObjInstance.highlight({
                element: "#dbh_dashboard #sachkostenabrechnungBox",
                popover: {
                    title: "So funktionierts",
                    description: `<video width="270" controls><source src="/Files/Videos/OBV_Sachkostenabrechnungen.mp4" /><source src="/Files/Videos/OBV_Sachkostenabrechnungen.webm" /></video><br /><br /><a id="btnShowHilfeSachkostenabrechnungenClose" class="btn btnDriverClose">Alles klar!</a>`
                },
                onHighlighted: () => {
                    window.setTimeout(() => {
                        $('#btnShowHilfeSachkostenabrechnungenClose').on('click', (e) => {
                            driverObjInstance.destroy();
                        });
                    }, 500);
                }
            });
            e.stopPropagation();
        });

    }, 2000);

    function BindDashboardAufgaben() {
        $('#FK_AdresseFuerAufgabenauswahl').change(function () {
            new dbh_ajax().sendGetRequest({
                actionName: "GetDashboardNachrichtenAufgaben",
                controllerName: "Home",
                parameter: [["fk_Adressen", $(this).val() as any], ["appKey", $('#dbh_NachrichtenAufgabenPlaceholder').attr('data-appKey')]],
                callbackSuccess: (ajaxResult: any) => {
                    $('#dbh_NachrichtenAufgabenPlaceholder').html(ajaxResult.responseText);
                }
            });
        });

        // Nachricht angeklickt
        $('#AufgabenTabelle .dbhNachricht').off('click');
        $('#AufgabenTabelle .dbhNachricht:not(.weiterleitung)').on('click', (e) => {
            new dbh_ajax().sendGetRequest({
                actionName: "GetNachrichtenPopupView",
                controllerName: "Home",
                parameter: [["id", $(e.currentTarget).attr('data-rowid')]],
                callbackSuccess: (ajaxResult: any) => {
                    $('#popup-placeholderDashboardAufgaben').html(ajaxResult.responseText);
                    (window as any).showPopup('PopupNachrichtenViewComponent');

                    $("#popup-placeholderDashboardAufgaben").ready(function () {
                        $('#btnPrimaryNachrichtGelesen').on('click', (e) => {
                            MarkiereNachrichtAlsGelesen(e, $('input[name="PK_Nachrichten"]').val());
                        });
                    });
                },
                callbackError: (ajaxResult: object) => {
                }
            }); e.stopPropagation();
        });

        $('#AufgabenTabelle .btnPrimaryNachrichtGelesen').off('click');
        $('#AufgabenTabelle .btnPrimaryNachrichtGelesen').on('click', (e) => {
            MarkiereNachrichtAlsGelesen(e, $(e.target).data("id"));
        });
    }

    function MarkiereNachrichtAlsGelesen(e, pk_aufgaben) {
        var form = dbh_helper.findNearestForm(e.currentTarget);

        new dbh_ajax().sendPostRequest({
            csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
            actionName: "NachrichtGelesen",
            controllerName: "Home",
            parameter: [["PK_Nachrichten", pk_aufgaben]],
            callbackSuccess: (ajaxResult: any) => {

                (window as any).hidePopup('PopupNachrichtenViewComponent');

                // Eintrag aus Tabelle entfernen                                   
                $('#AufgabenTabelle #listeAllerAufgabenUndNachrichten li[data-rowid="' + pk_aufgaben + '"]').first().remove();

                if ($('#AufgabenTabelle #listeAllerAufgabenUndNachrichten').children().length == 0) {
                    new dbh_ajax().sendGetRequest({
                        actionName: "GetDashboardNachrichtenAufgaben",
                        controllerName: "Home",
                        parameter: [["fk_Adressen", $('#dbh_NachrichtenAufgabenPlaceholder').attr('data-fk_Adressen')], ["appKey", $('#dbh_NachrichtenAufgabenPlaceholder').attr('data-appKey')]],
                        callbackSuccess: (ajaxResult: any) => {
                            $('#dbh_NachrichtenAufgabenPlaceholder').html(ajaxResult.responseText);
                        }
                    });
                }
            },
            callbackError: (ajaxResult: any) => {
            }
        });

        e.stopPropagation();
    }

    function DashboardAufgabenPostback(e, action, formIds) {
        let dbhCustomValidation = new dbh_custom_validation();
        if (formIds != null && formIds.length > 0) {
            for (var i = 0; i < formIds.length; i++) {
                if (!dbhCustomValidation.validateForm(formIds[i])) {
                    return;
                }
            }
        }

        var form = dbh_helper.findNearestForm(e.currentTarget);

        new dbh_ajax().sendPostRequest({
            csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
            actionName: action,
            controllerName: "Home",
            parameter: dbh_helper.getParameterStringForForm(form),
            callbackSuccess: (ajaxResult: any) => {
                $('.dbhDokumentWeiterleitenStep').fadeOut(400);
                $('.dbhDokumentWeiterleitenStep btnPrimary').on("click", function () {
                    (window as any).hidePopup('PopupAufgabenVorverarbeitungViewComponent');
                });
                window.setTimeout(function () {
                    $('.dbhDokumentWeiterleitenStep8').fadeIn();
                }, 400);

                let pk_Aufgaben = $('input[name="PK_Aufgaben"]').val();
                // Eintrag aus Tabelle entfernen                
                $('#AufgabenTabelle #listeAllerAufgabenUndNachrichten li[data-rowid="' + pk_Aufgaben + '"]').first().remove();

                if ($('#AufgabenTabelle #listeAllerAufgabenUndNachrichten').children().length == 0) {
                    new dbh_ajax().sendGetRequest({
                        actionName: "GetDashboardNachrichtenAufgaben",
                        controllerName: "Home",
                        parameter: [["fk_Adressen", $('#dbh_NachrichtenAufgabenPlaceholder').attr('data-fk_Adressen')], ["appKey", $('#dbh_NachrichtenAufgabenPlaceholder').attr('data-appKey')]],
                        callbackSuccess: (ajaxResult: any) => {
                            $('#dbh_NachrichtenAufgabenPlaceholder').html(ajaxResult.responseText);
                        }
                    });
                }
            },
            callbackError: (ajaxResult: any) => {
            }
        });
    }

    const initSortableFavList = () => {
        const $table = $("#favAdressTable");
        for (let i = 0; i < $table.length; i++) {
            if ($($table[i]).find("[data-sortkey]").length > 0) {
                (<any>$($table).find(".dbhSuchergebnisGrid")).sortable({
                    update: function (event, ui) {
                        const controllerName = "Home";
                        const $sortedItems = $("#favAdressTable .dbhSuchergebnisGrid [data-sortkey]");
                        const sortedKeys = [];
                        for (let i = 0; i < $sortedItems.length; i++) {
                            sortedKeys.push($($sortedItems[i]).data().sortkey);
                        }

                        const parameter = [["listOfKeys", sortedKeys.join(",")]];

                        //console.log("parameter: ", parameter);
                        sendGetRequest("SortFavAdressen", controllerName, parameter, "");
                    }
                });
            }
        }
    }
}

const sendGetRequest = (actionName, controllerName, parameter, htmlId, doOnSuccess = null) => {
    return new dbh_ajax().sendGetRequest({
        actionName: actionName,
        controllerName: controllerName,
        parameter: parameter,
        callbackSuccess: (ajaxResult: any) => {
            if (htmlId !== undefined && htmlId !== null) {
                $(`${htmlId}`).html(ajaxResult.responseText);
            }
            if (doOnSuccess !== undefined && doOnSuccess !== null) {
                doOnSuccess();
            }
        },
        callbackError: (ajaxResult: object) => {

        }
    });
}